import { AnalyticsProvider } from './analytics-provider';
import { Logger } from '../../utils/Logger';

const analyticsProvider = new AnalyticsProvider();
export class GoogleAnalytics {
    clearUser() {
        // not sure how
    }

    setUserId(userId) {
        try {
            analyticsProvider.setUserId(userId);
        } catch (e) {
            Logger.notify(e);
        }
    }

    setCurrentScreen(screenName, className) {
        try {
            analyticsProvider.setCurrentScreen(screenName, className);
        } catch (e) {
            Logger.notify(e);
        }
    }

    logEvent(action, category, label) {
        try {
            analyticsProvider.logEvent(action, category, label);
        } catch (e) {
            Logger.notify(e);
        }
    }

    logEventWithParamaters(action, params) {
        try {
            analyticsProvider.logEventWithParamaters(action, params);
        } catch (e) {
            Logger.notify(e);
        }
    }
}
